import {useSelector} from 'react-redux';

import * as selectors from 'nutshell-core/territories/territories-selectors';

import {DropdownSelectInline} from 'shells/select-inline/dropdown-select-inline';

import {appHistory} from '../../../history';
import type {NutshellState} from '../../../store';

interface Props {
    territoryId: string | null | undefined;
    onUpdatePeepTerritory: (territoryId: string | null, territoryName: string | null) => void;
    isDisabled?: boolean;
    canAccessSetup: boolean;
}

export function PeepTerritorySelectInline(props: Props) {
    // @ts-expect-error
    const territories = useSelector((state: NutshellState) => selectors.getAll(state, null));

    const selectedTerritory = props.territoryId
        ? // @ts-expect-error
          territories.find((territory) => territory.id === props.territoryId)
        : undefined;

    return (
        <DropdownSelectInline
            options={territories}
            selectedValue={selectedTerritory}
            onChange={(selected) => {
                props.onUpdatePeepTerritory(
                    selected ? selected.id : null,
                    selected ? selected.name : null
                );
            }}
            onClear={() => {
                props.onUpdatePeepTerritory(null, null);
            }}
            isDisabled={props.isDisabled}
            footerButton={
                props.canAccessSetup && {
                    label: 'Manage territories',
                    onClick: () => {
                        appHistory.push('/setup/territory');
                    },
                }
            }
        />
    );
}
